import { CLOUD_VENDOR, DESTINATION_TYPE } from "@/server/types/export";

export const DEST_TYPE_LABELS: Record<string, string> = {
  [DESTINATION_TYPE.FHIR_SERVER]: "FHIR Server",
  [CLOUD_VENDOR.AWS]: "AWS S3",
  [CLOUD_VENDOR.GCS]: "GCS",
  [CLOUD_VENDOR.AZURE]: "Azure Blob",
};

export const DESTINATION_LOGOS: Record<string, string> = {
  [CLOUD_VENDOR.AWS]: "/assets/aws.png",
  [CLOUD_VENDOR.GCS]: "/assets/gcs.png",
  [CLOUD_VENDOR.AZURE]: "/assets/azure.png",
  [DESTINATION_TYPE.FHIR_SERVER]: "/assets/fhir.png",
};

export const STATUS_BADGE_COLORS: Record<string, string> = {
  completed: "bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400",
  queued: "bg-gray-100 dark:bg-gray-900/30 text-gray-700 dark:text-gray-400",
  running: "bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400",
  partial: "bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400",
  failed: "bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400",
};

export const TRIGGER_LABELS: Record<string, string> = {
  pull_completed: "Pull completed",
  destination_added: "New destination",
  manual_retry: "Manual retry",
  reactivated: "Reactivated",
  sample_load_complete: "Sample load complete",
  fhir_import_complete: "FHIR import complete",
};

export const STATUS_TABS = [
  { key: "all", label: "All" },
  { key: "queued", label: "Queued" },
  { key: "completed", label: "Completed" },
  { key: "partial", label: "Partial" },
  { key: "failed", label: "Failed" },
] as const;

export const DEMO_RUNS = [
  {
    id: "demo-queued-1",
    destination_name: "hapi.fhir.org",
    destination_type: DESTINATION_TYPE.FHIR_SERVER,
    cloud_vendor: null,
    status: "queued",
    trigger: "pull_completed",
    delta_from: new Date(Date.now() - 2 * 60000).toISOString(),
    patients_total: null,
    patients_succeeded: 0,
    patients_failed: 0,
    items_exported: 0,
    started_at: new Date(Date.now() - 2 * 60000).toISOString(),
    completed_at: null,
    error_message: null,
  },
  {
    id: "demo-0",
    destination_name: "prod-patient-export",
    destination_type: DESTINATION_TYPE.OBJECT_STORAGE,
    cloud_vendor: CLOUD_VENDOR.AWS,
    status: "running",
    trigger: "pull_completed",
    delta_from: new Date(Date.now() - 5 * 60000).toISOString(),
    patients_total: 142,
    patients_succeeded: 67,
    patients_failed: 0,
    items_exported: 1823,
    started_at: new Date(Date.now() - 5 * 60000).toISOString(),
    completed_at: null,
    error_message: null,
  },
  {
    id: "demo-1",
    destination_name: "prod-patient-export",
    destination_type: DESTINATION_TYPE.OBJECT_STORAGE,
    cloud_vendor: CLOUD_VENDOR.AWS,
    status: "completed",
    trigger: "pull_completed",
    delta_from: new Date(Date.now() - 3 * 3600000).toISOString(),
    patients_total: 142,
    patients_succeeded: 142,
    patients_failed: 0,
    items_exported: 3847,
    started_at: new Date(Date.now() - 2 * 3600000).toISOString(),
    completed_at: new Date(Date.now() - 2 * 3600000 + 102000).toISOString(),
    error_message: null,
  },
  {
    id: "demo-2",
    destination_name: "hapi.fhir.org",
    destination_type: DESTINATION_TYPE.FHIR_SERVER,
    cloud_vendor: null,
    status: "completed",
    trigger: "pull_completed",
    delta_from: new Date(Date.now() - 35 * 60000).toISOString(),
    patients_total: 1,
    patients_succeeded: 1,
    patients_failed: 0,
    items_exported: 23,
    started_at: new Date(Date.now() - 35 * 60000).toISOString(),
    completed_at: new Date(Date.now() - 35 * 60000 + 12000).toISOString(),
    error_message: null,
  },
  {
    id: "demo-3",
    destination_name: "hapi.fhir.org",
    destination_type: DESTINATION_TYPE.FHIR_SERVER,
    cloud_vendor: null,
    status: "failed",
    trigger: "pull_completed",
    delta_from: null,
    patients_total: 142,
    patients_succeeded: 38,
    patients_failed: 104,
    items_exported: 1205,
    started_at: new Date(Date.now() - 3 * 3600000).toISOString(),
    completed_at: new Date(Date.now() - 3 * 3600000 + 45000).toISOString(),
    error_message: "OAuth token refresh failed — 401 Unauthorized",
  },
  {
    id: "demo-4",
    destination_name: "prod-patient-export",
    destination_type: DESTINATION_TYPE.OBJECT_STORAGE,
    cloud_vendor: CLOUD_VENDOR.AWS,
    status: "completed",
    trigger: "destination_added",
    delta_from: null,
    patients_total: 1,
    patients_succeeded: 1,
    patients_failed: 0,
    items_exported: 847,
    started_at: new Date(Date.now() - 24 * 3600000).toISOString(),
    completed_at: new Date(Date.now() - 24 * 3600000 + 258000).toISOString(),
    error_message: null,
  },
];
